import { useProductSliderContext } from "@/components/Product/ProductSlider/context/productSlider.context";
import { useProductSliderSourceContext } from "@/components/Product/ProductSlider/context/productSliderSource.context";

import { Header } from "./components/header/header";
import { Slider } from "./components/slider/slider";
import { Base } from "./productSlider.base";

export const ProductSlider = Object.assign(Base, {
    useContext: useProductSliderContext,
    useSource: useProductSliderSourceContext,
    Header: Header,
    Slider: Slider
});
